import { NgModule } from '@angular/core';
import { FirstUpperCasePipe } from '../firstUppercase.pipe';

@NgModule({
  declarations: [FirstUpperCasePipe],
  exports: [FirstUpperCasePipe],
})
export class FirstUpperCasePipeModule {}
